/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_Share_DeniedInputs */

const en_views_share_denied = /** @type {(inputs: Views_Share_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You may not share views in this product.`)
};

const de_views_share_denied = /** @type {(inputs: Views_Share_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du darfst in diesem Produkt keine Ansichten teilen.`)
};

/**
* | output |
* | --- |
* | "You may not share views in this product." |
*
* @param {Views_Share_DeniedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_share_denied = /** @type {((inputs?: Views_Share_DeniedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_Share_DeniedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_share_denied(inputs)
	return en_views_share_denied(inputs)
});